( function ($) {
    $(document).ready(function () {
        childrenSlider();
    });
    function childrenSlider() {
        var wraps = $('.posts_carousel .children_section');
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                var slider = wrap.find('.children_previews .wrap.carousel .inner_wrapper');
                var children = slider.find('.item_wrap');
                if((children.length > 2 && !globalVar.is_phone) || (children.length > 1 && globalVar.is_phone))  {
                    slider.parent().append('<a class="arrow prev" href="javascript:;">' +
                        '</a><a class="arrow next" href="javascript:;"></a>');
                    if (slider.length > 0) {
                        slider.slick({
                            rtl: rtl,
                            infinite: true,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            nextArrow: wrap.parent().find('.next'),
                            prevArrow: wrap.parent().find('.prev'),
                            dots: false,
                            responsive: [
                                {
                                    breakpoint: 992,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    }
                                },
                            ]
                        });
                    }
                }
                wrap.find('.arrow').on('click', function(){
                    lazyLoadInstance.update();
                });
            })
        }
    }

}(jQuery) );
